import { Mail } from "lucide-react";
import { EMAILS, CONTACT_REASONS } from "@/lib/emails";

export default function CguPage() {
  return (
    <main className="max-w-3xl mx-auto px-6 py-10" data-testid="cgu-page">
      <h1 className="font-display text-4xl font-extrabold tracking-tight">CGU & non-responsabilite</h1>
      <p className="text-[var(--ink-soft)] mt-2">Derniere mise a jour : {new Date().toLocaleDateString("fr-FR")}</p>

      <article className="mt-8 glass-card p-8 space-y-5 text-[15px] leading-relaxed">
        <section>
          <h2 className="font-bold text-lg mb-2">1. Objet</h2>
          <p>Fodindin est une plateforme de mise en relation entre particuliers, professionnels, agences et hotels en Cote d'Ivoire. Les annonces sont publiees librement par les utilisateurs.</p>
        </section>
        <section>
          <h2 className="font-bold text-lg mb-2">2. Non-responsabilite</h2>
          <p>Fodindin n'est ni vendeur, ni acheteur, ni intermediaire commercial. La verification des biens, identites et transactions reste de la responsabilite des parties. Toute transaction se fait aux risques des utilisateurs.</p>
        </section>
        <section>
          <h2 className="font-bold text-lg mb-2">3. Annonces premium</h2>
          <p>Les options premium (mise en avant, photos supplementaires, video 10 s, badge verifie) sont facturees 2 000 FCFA / mois et payables via Wave, Orange Money ou MTN Mobile Money.</p>
        </section>
        <section>
          <h2 className="font-bold text-lg mb-2">4. Programme hotelier</h2>
          <p>Le module hotelleries propose des remises de 40% en heures creuses et 20% en forte affluence afin d'optimiser le taux d'occupation des etablissements partenaires.</p>
        </section>
        <section>
          <h2 className="font-bold text-lg mb-2">5. Signalements & retrait de contenu</h2>
          <p>
            Pour signaler une annonce frauduleuse ou demander la suppression d'un contenu, contactez{" "}
            <a href={`mailto:${EMAILS.admin}`} className="text-orange-600 font-semibold">{EMAILS.admin}</a>{" "}
            avec l'URL concernee et le motif. Les demandes legitimes sont traitees sous 48 h.
          </p>
        </section>
        <section>
          <h2 className="font-bold text-lg mb-2">6. Contact</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-2">
            {CONTACT_REASONS.map((r) => (
              <a
                key={r.key}
                href={`mailto:${r.email}`}
                className="flex items-start gap-3 p-3 rounded-2xl border border-[var(--line)] hover:border-orange-300 transition-colors"
                data-testid={`cgu-email-${r.key}`}
              >
                <div className="w-9 h-9 rounded-xl bg-orange-50 text-orange-600 grid place-items-center shrink-0"><Mail size={14} /></div>
                <div>
                  <div className="font-bold text-sm">{r.label}</div>
                  <div className="text-xs text-orange-600 font-semibold">{r.email}</div>
                </div>
              </a>
            ))}
          </div>
        </section>
      </article>
    </main>
  );
}
